import Storages from 'storages';
import TVKeyControl from 'entities/tvKeyControl';
import TizenTVControls from 'drivers/tizen/tizenKey';
import TizenTEPControls from 'drivers/tizenTEP/tizenTEPKey';
import DefaultTVControls from 'drivers/default/defaultKey';
import SamsungTVControls from 'drivers/samsung/samsungKey';
import WebOSTVControls from 'drivers/webosLg/webosLgKey';
import StorageKeys from 'enum/storages.enum';
import { isHdmiDefaultPreviewEnabled } from 'utils/hdmi/hdmiEnv';

function isDefaultDevice() {
  var deviceList = Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST);
  return !!(deviceList && deviceList.isDEFAULT);
}

async function loadHdmiDriver() {
  var deviceList = Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST);
  if (deviceList.isTIZEN) {
    return import('drivers/tizen/tizen');
  }
  if (deviceList.isTIZEN_TEP) {
    return import('drivers/tizenTEP/tizenTEP');
  }
  if (isDefaultDevice() && isHdmiDefaultPreviewEnabled()) {
    return import('drivers/default/hdmiDefault');
  }
  return null;
}
async function registerKey() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return await Samsung.default.registerKey();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return await Tizen.default.registerKey();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return await TizenTEP.default.registerKey();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.registerKey();
  } else return '';
}

async function getTVControl() {
  var tvKeyControl;
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    tvKeyControl = new TVKeyControl(
      SamsungTVControls.LEFT,
      SamsungTVControls.RIGHT,
      SamsungTVControls.UP,
      SamsungTVControls.DOWN,
      SamsungTVControls.ENTER,
      SamsungTVControls.RETURN,
      SamsungTVControls.RETURN,
      SamsungTVControls.N0,
      SamsungTVControls.N1,
      SamsungTVControls.N2,
      SamsungTVControls.N3,
      SamsungTVControls.N4,
      SamsungTVControls.N5,
      SamsungTVControls.N6,
      SamsungTVControls.N7,
      SamsungTVControls.N8,
      SamsungTVControls.N9,
      SamsungTVControls.RED,
      SamsungTVControls.GREEN,
      SamsungTVControls.YELLOW,
      SamsungTVControls.BLUE,
      SamsungTVControls.PLAY,
      SamsungTVControls.PAUSE,
      SamsungTVControls.STOP,
      SamsungTVControls.REC,
      SamsungTVControls.FF,
      SamsungTVControls.RW,
      null,
      SamsungTVControls.TOOLS,
      SamsungTVControls.CH_UP,
      SamsungTVControls.CH_DOWN,
      null,
      SamsungTVControls.PRECH,
      null,
      SamsungTVControls.EXIT,
      SamsungTVControls.INFO
    );

    return tvKeyControl;
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    tvKeyControl = new TVKeyControl(
      TizenTVControls.LEFT,
      TizenTVControls.RIGHT,
      TizenTVControls.UP,
      TizenTVControls.DOWN,
      TizenTVControls.ENTER,
      TizenTVControls.RETURN,
      TizenTVControls.RETURN,
      TizenTVControls.N0,
      TizenTVControls.N1,
      TizenTVControls.N2,
      TizenTVControls.N3,
      TizenTVControls.N4,
      TizenTVControls.N5,
      TizenTVControls.N6,
      TizenTVControls.N7,
      TizenTVControls.N8,
      TizenTVControls.N9,
      TizenTVControls.RED,
      TizenTVControls.GREEN,
      TizenTVControls.YELLOW,
      TizenTVControls.BLUE,
      TizenTVControls.PLAY,
      TizenTVControls.PAUSE,
      TizenTVControls.STOP,
      TizenTVControls.REC,
      TizenTVControls.FF,
      TizenTVControls.RW,
      TizenTVControls.PLAYPAUSE,
      TizenTVControls.TOOLS,
      TizenTVControls.CH_UP,
      TizenTVControls.CH_DOWN,
      null,
      TizenTVControls.PRECH,
      null,
      TizenTVControls.EXIT,
      TizenTVControls.INFO
    );

    return tvKeyControl;
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    tvKeyControl = new TVKeyControl(
      TizenTEPControls.LEFT,
      TizenTEPControls.RIGHT,
      TizenTEPControls.UP,
      TizenTEPControls.DOWN,
      TizenTEPControls.ENTER,
      TizenTEPControls.RETURN,
      TizenTEPControls.RETURN,
      TizenTEPControls.N0,
      TizenTEPControls.N1,
      TizenTEPControls.N2,
      TizenTEPControls.N3,
      TizenTEPControls.N4,
      TizenTEPControls.N5,
      TizenTEPControls.N6,
      TizenTEPControls.N7,
      TizenTEPControls.N8,
      TizenTEPControls.N9,
      TizenTEPControls.RED,
      TizenTEPControls.GREEN,
      TizenTEPControls.YELLOW,
      TizenTEPControls.BLUE,
      TizenTEPControls.PLAY,
      TizenTEPControls.PAUSE,
      TizenTEPControls.STOP,
      TizenTEPControls.REC,
      TizenTEPControls.FF,
      TizenTEPControls.RW,
      TizenTEPControls.PLAYPAUSE,
      TizenTEPControls.TOOLS,
      TizenTEPControls.CH_UP,
      TizenTEPControls.CH_DOWN,
      null,
      TizenTEPControls.PRECH,
      null,
      TizenTEPControls.EXIT,
      TizenTEPControls.INFO
    );

    return tvKeyControl;
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    tvKeyControl = new TVKeyControl(
      DefaultTVControls.LEFT,
      DefaultTVControls.RIGHT,
      DefaultTVControls.UP,
      DefaultTVControls.DOWN,
      DefaultTVControls.ENTER,
      DefaultTVControls.RETURN,
      DefaultTVControls.RETURN,
      DefaultTVControls.N0,
      DefaultTVControls.N1,
      DefaultTVControls.N2,
      DefaultTVControls.N3,
      DefaultTVControls.N4,
      DefaultTVControls.N5,
      DefaultTVControls.N6,
      DefaultTVControls.N7,
      DefaultTVControls.N8,
      DefaultTVControls.N9,
      DefaultTVControls.RED,
      DefaultTVControls.GREEN,
      DefaultTVControls.YELLOW,
      DefaultTVControls.BLUE,
      DefaultTVControls.PLAY,
      DefaultTVControls.PAUSE,
      DefaultTVControls.STOP,
      DefaultTVControls.REC,
      DefaultTVControls.FF,
      DefaultTVControls.RW,
      DefaultTVControls.PLAYPAUSE,
      DefaultTVControls.TOOLS,
      DefaultTVControls.CH_UP,
      DefaultTVControls.CH_DOWN,
      null,
      DefaultTVControls.PRECH,
      null,
      DefaultTVControls.EXIT,
      DefaultTVControls.INFO
    );

    return tvKeyControl;
  }else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    tvKeyControl = new TVKeyControl(
      DefaultTVControls.LEFT,
      DefaultTVControls.RIGHT,
      DefaultTVControls.UP,
      DefaultTVControls.DOWN,
      DefaultTVControls.ENTER,
      DefaultTVControls.RETURN,
      DefaultTVControls.RETURN,
      DefaultTVControls.N0,
      DefaultTVControls.N1,
      DefaultTVControls.N2,
      DefaultTVControls.N3,
      DefaultTVControls.N4,
      DefaultTVControls.N5,
      DefaultTVControls.N6,
      DefaultTVControls.N7,
      DefaultTVControls.N8,
      DefaultTVControls.N9,
      DefaultTVControls.RED,
      DefaultTVControls.GREEN,
      DefaultTVControls.YELLOW,
      DefaultTVControls.BLUE,
      DefaultTVControls.PLAY,
      DefaultTVControls.PAUSE,
      DefaultTVControls.STOP,
      DefaultTVControls.REC,
      DefaultTVControls.FF,
      DefaultTVControls.RW,
      DefaultTVControls.PLAYPAUSE,
      DefaultTVControls.TOOLS,
      DefaultTVControls.CH_UP,
      DefaultTVControls.CH_DOWN,
      null,
      DefaultTVControls.PRECH,
      null,
      DefaultTVControls.EXIT,
      DefaultTVControls.INFO
    );

    return tvKeyControl;
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    tvKeyControl = new TVKeyControl(
      WebOSTVControls.LEFT,
      WebOSTVControls.RIGHT,
      WebOSTVControls.UP,
      WebOSTVControls.DOWN,
      WebOSTVControls.ENTER,
      WebOSTVControls.RETURN,
      WebOSTVControls.RETURN,
      WebOSTVControls.N0,
      WebOSTVControls.N1,
      WebOSTVControls.N2,
      WebOSTVControls.N3,
      WebOSTVControls.N4,
      WebOSTVControls.N5,
      WebOSTVControls.N6,
      WebOSTVControls.N7,
      WebOSTVControls.N8,
      WebOSTVControls.N9,
      WebOSTVControls.RED,
      WebOSTVControls.GREEN,
      WebOSTVControls.YELLOW,
      WebOSTVControls.BLUE,
      WebOSTVControls.PLAY,
      WebOSTVControls.PAUSE,
      WebOSTVControls.STOP,
      WebOSTVControls.REC,
      WebOSTVControls.FF,
      WebOSTVControls.RW,
      WebOSTVControls.PLAYPAUSE,
      WebOSTVControls.TOOLS,
      WebOSTVControls.CH_UP,
      WebOSTVControls.CH_DOWN,
      null,
      WebOSTVControls.PRECH,
      null,
      WebOSTVControls.EXIT,
      WebOSTVControls.INFO
    );

    return tvKeyControl;
  } else return '';
}

async function getFirmware() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.getFirmware();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.getFirmware();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getFirmware();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.getFirmware();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.getFirmware();
  } else return '';
}

async function getUID() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.getUID();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.getUID();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getUID();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.getUID();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.getUID();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    var UID = '';
    await LG.default.getUID().then((response) => {
      UID = response;
    });
    return UID;
  } else return '';
}

async function getIP() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.getIP();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.getIP();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getIP();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.getIP();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.getIP();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    var ip = '';
    await LG.default.getIP().then((response) => {
      ip = response;
    });
    return ip;
  } else return '';
}

async function getDeviceName() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.getDeviceName();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.getDeviceName();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getDeviceName();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.getDeviceName();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.getDeviceName();
  } else return '';
}
async function getCountry() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.getCountry();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.getCountry();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getCountry();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.getCountry();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.getCountry();
  } else return '';
}

async function getLanguage() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.getLanguage();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.getLanguage();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getLanguage();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.getLanguage();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.getLanguage();
  } else return '';
}

async function getCurrentDateTime() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.getDate();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.getCurrentDateTime();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getCurrentDateTime();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.getCurrentDateTime();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.getCurrentDateTime();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    var dateTime = '';
    await LG.default.getCurrentDateTime().then((response) => {
      dateTime = response;
    });
    return dateTime;
  } else return '';
}

async function getDate() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.getDate();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.getDate();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getDate();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.getDate();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.getDate();
  } else return '';
}
async function getnetworkStatus() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.getnetworkStatus();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.getnetworkStatus();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getnetworkStatus();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.getnetworkStatus();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.getnetworkStatus();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    var networkStatus = false;
    await LG.default.getnetworkStatus().then((response) => {
      networkStatus = response;
    });
    return networkStatus;
  } else return '';
}

async function restartScreen() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.restartScreen();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.restartScreen();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.restartScreen();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.restartScreen();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.restartScreen();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    return LG.default.restartScreen();
  } else return '';
}

async function turnOffScreen() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.turnOffScreen();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.turnOffScreen();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.turnOffScreen();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.turnOffScreen();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.turnOffScreen();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    return LG.default.turnOffScreen();
  } else return '';
}
async function volumeMuteOn() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.volumeMuteOn();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.volumeMuteOn();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.volumeMuteOn();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.volumeMuteOn();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.volumeMuteOn();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    return LG.default.volumeMuteOn();
  } else return '';
}

async function volumeMuteOff() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.volumeMuteOff();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.volumeMuteOff();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.volumeMuteOff();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.volumeMuteOff();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.volumeMuteOff();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    return LG.default.volumeMuteOff();
  } else return '';
}

async function setVolumeLevel() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.setVolumeLevel();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.setVolumeLevel();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.setVolumeLevel();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.setVolumeLevel();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.setVolumeLevel();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    return LG.default.setVolumeLevel();
  } else return '';
}

async function unsetVolumeLevel() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.unsetVolumeLevel();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.unsetVolumeLevel();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.unsetVolumeLevel();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.unsetVolumeLevel();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.unSetVolumeLevel();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    return LG.default.unSetVolumeLevel();
  } else return '';
}

async function changeLanguage() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isSAMSUNG) {
    const Samsung = await import('drivers/samsung/samsung');
    return Samsung.default.changeLanguage();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.changeLanguage();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.changeLanguage();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isDEFAULT) {
    const Default = await import('drivers/default/default');
    return Default.default.changeLanguage();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.changeLanguage();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    return LG.default.changeLanguage();
  } else return '';
}

async function castingShow() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.castingShow();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.castingShow();
  } else return '';
}

async function castingHide() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.castingHide();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.castingHide();
  } else return '';
}

async function getHdmiInputs() {
  var driver = await loadHdmiDriver();
  if (!driver) {
    return [];
  }
  return driver.default.getHdmiInputs();
}

async function showHdmiInput(portNumber) {
  var driver = await loadHdmiDriver();
  if (!driver) {
    return '';
  }
  return driver.default.showHdmiInput(portNumber);
}

async function showVideoSource(type, number) {
  var driver = await loadHdmiDriver();
  if (!driver) {
    return '';
  }
  if (typeof driver.default.showVideoSource === 'function') {
    return driver.default.showVideoSource(type, number);
  }
  if (String(type).toUpperCase() === 'HDMI') {
    return driver.default.showHdmiInput(number);
  }
  return '';
}

async function hideHdmiInput() {
  var driver = await loadHdmiDriver();
  if (!driver) {
    return '';
  }
  return driver.default.hideHdmiInput();
}

async function addHdmiSourceChangeListener(callback) {
  var driver = await loadHdmiDriver();
  if (!driver) {
    return null;
  }
  return driver.default.addHdmiSourceChangeListener(callback);
}

async function removeHdmiSourceChangeListener() {
  var driver = await loadHdmiDriver();
  if (!driver) {
    return;
  }
  return driver.default.removeHdmiSourceChangeListener();
}

async function setVolumeUp() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.setVolumeUp();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.setVolumeUp();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    return LG.default.setVolumeUp();
  } else return '';
}

async function setVolumeDown() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.setVolumeDown();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.setVolumeDown();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isWEBOS) {
    const LG = await import('drivers/webosLg/webosLg');
    return LG.default.setVolumeDown();
  } else return '';
}

async function launchYoutube() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.launchYoutube();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.launchYoutube();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.launchYoutube();
  } else return '';
}

async function launchNetflix() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.launchNetflix();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.launchNetflix();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.launchNetflix();
  } else return '';
}

async function launchInternet() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.launchInternet();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.launchInternet();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.launchInternet();
  } else return '';
}

async function launchPrimeVideo() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN) {
    const Tizen = await import('drivers/tizen/tizen');
    return Tizen.default.launchPrimeVideo();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.launchPrimeVideo();
  } else if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isANDROID) {
    const Android = await import('drivers/android/android');
    return Android.default.launchPrimeVideo();
  } else return '';
}

// ---------------------------------------------------------------------------
// TEP-only facade methods (TZ > 6.0)
// Safe to call on any device — returns '' on non-TEP.
// ---------------------------------------------------------------------------

// Power (webapis.remotepower)
async function getPowerState() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getPowerState();
  } else return '';
}

async function getVirtualStandbyMode() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getVirtualStandbyMode();
  } else return '';
}

async function powerOn() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.powerOn();
  } else return '';
}

// CustomApp (webapis.systemcontrol)
async function setCustomAppInfo(downloadServerAddress, connectionTimeout) {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.setCustomAppInfo(downloadServerAddress, connectionTimeout);
  } else return '';
}

async function getCustomAppInfo() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getCustomAppInfo();
  } else return '';
}

// NTP (webapis.systemcontrol)
async function setNTP(serverAddress) {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.setNTP(serverAddress);
  } else return '';
}

async function getNTP() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getNTP();
  } else return '';
}

// Time (webapis.timer)
async function setCurrentTime(date) {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.setCurrentTime(date);
  } else return '';
}

async function getCurrentTime() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.getCurrentTime();
  } else return '';
}

// Network config (webapis.network)
async function setNetworkConfig(config) {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    if (config.ipMode)  TizenTEP.default.setIpMode(config.ipMode);
    if (config.ip)      TizenTEP.default.setIp(config.ip);
    if (config.dns)     TizenTEP.default.setDNSServer(config.dns);
    if (config.gateway) TizenTEP.default.setGateway(config.gateway);
    if (config.subnet)  TizenTEP.default.setSubnetMask(config.subnet);
  } else return '';
}

// IPTV Player (webapis.avplay)
async function playIPTV(url, listener, x, y, w, h) {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.playIPTV(url, listener, x, y, w, h);
  } else return '';
}

async function stopIPTV() {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.stopIPTV();
  } else return '';
}

// Hosted App
async function launchHostedApp(url) {
  if (Storages.MainStorage.getItem(StorageKeys.Keys.DEVICELIST).isTIZEN_TEP) {
    const TizenTEP = await import('drivers/tizenTEP/tizenTEP');
    return TizenTEP.default.launchHostedApp(url);
  } else return '';
}

const obj = {
  registerKey,
  getTVControl,
  getFirmware,
  getDeviceName,
  getIP,
  getUID,
  getCountry,
  getLanguage,
  getCurrentDateTime,
  getDate,
  getnetworkStatus,
  restartScreen,
  turnOffScreen,
  setVolumeUp,
  setVolumeDown,
  volumeMuteOn,
  volumeMuteOff,
  setVolumeLevel,
  unsetVolumeLevel,
  changeLanguage,
  castingShow,
  castingHide,
  getHdmiInputs,
  showHdmiInput,
  showVideoSource,
  hideHdmiInput,
  addHdmiSourceChangeListener,
  removeHdmiSourceChangeListener,
  launchYoutube,
  launchNetflix,
  launchInternet,
  launchPrimeVideo,
  // TEP-only (TZ > 6.0)
  getPowerState,
  getVirtualStandbyMode,
  powerOn,
  setCustomAppInfo,
  getCustomAppInfo,
  setNTP,
  getNTP,
  setCurrentTime,
  getCurrentTime,
  setNetworkConfig,
  playIPTV,
  stopIPTV,
  launchHostedApp,
};

export default obj;
